define('drops/chart_v2/chart_v2',[
    'jquery',
    'lq/Drop',
    'drops/chart_v2/Chart_v2Defaults',
    'lq/frontendModules'
], function ($, Drop, designDefaults, FrontendModules) {    
    'use strict';

    var Chart = function (options) {
        Drop.call(this, $('<div>'), designDefaults, options);

        this.$canvas = $('<canvas>').appendTo(this.$element);
    };

    Drop.extend(Chart);

    Chart.typeName = 'Chart_v2';

    Chart.prototype.preRender = function () {
        var self = this;
    
        this.ChartComponent = null;
    
        this.piping.visibility.apply(this);
        this.applyPosition();

        FrontendModules.load('chart', true)
            .then(this.setChart.bind(this));

        this.piping.datasources.registerDatasourceListener(
            this.data.dataSource,
            function (data) {
                self.dataSourceResult = data;

                if (self.ChartComponent)
                    self.setData(data);
                }
        );
    };

    Chart.prototype.setChart = function (ChartRendered) {
        this.ChartComponent = ChartRendered;

        if (this.dataSourceResult)
            this.setData(this.dataSourceResult);
    };

    Chart.prototype.setData = function (dataSourceResult) {
        var config = {
            labelType: this.data.labelType,
            backgroundColor: this.data.backgroundColor,
            chartPadding: this.data.chartPadding,

            showXAxis: this.data.showXAxis,
            axisXColor: this.data.axisXColor,
            axisXWidth: this.data.axisXWidth,
            showXAxisLabel: this.data.showXAxisLabel,
            axisXLabel: this.data.axisXLabel,
            axisXLabelFont: this.data.axisXLabelFont,
            axisXLabelAlignment: this.data.axisXLabelAlignment,
            axisXLabelPadding: this.data.axisXLabelPadding,
            showXAxisTicks: this.data.showXAxisTicks,
            axisXTickColor: this.data.axisXTickColor,
            axisXTickWidth: this.data.axisXTickWidth,
            axisXTickLength: this.data.axisXTickLength,
            axisXDashedTick: this.data.axisXDashedTick,
            axisXDashedTickLength: this.data.axisXDashedTickLength,
            axisXDashedTickSpacing: this.data.axisXDashedTickSpacing,
            showXAxisTickLabels: this.data.showXAxisTickLabels,
            axisXTickLabelAlignment: this.data.axisXTickLabelAlignment,
            axisXTickLabelFont: this.data.axisXTickLabelFont,
            axisXTickLabelPadding: this.data.axisXTickLabelPadding,
            axisXTickLabelMirror: this.data.axisXTickLabelMirror,
            axisXLabelAutoSkip: this.data.axisXLabelAutoSkip,
            axisXLabelAutoSkipPadding: this.data.axisXLabelAutoSkipPadding,
            axisXLabelMinRotation: this.data.axisXLabelMinRotation,
            axisXLabelMaxRotation: this.data.axisXLabelMaxRotation,

            showYAxis: this.data.showYAxis,
            axisYColor: this.data.axisYColor,
            axisYWidth: this.data.axisYWidth,
            showYAxisLabel: this.data.showYAxisLabel,
            axisYLabel: this.data.axisYLabel,
            axisYLabelFont: this.data.axisYLabelFont,
            axisYLabelAlignment: this.data.axisYLabelAlignment,
            axisYLabelPadding: this.data.axisYLabelPadding,
            showYAxisTicks: this.data.showYAxisTicks,
            axisYTickColor: this.data.axisYTickColor,
            axisYTickWidth: this.data.axisYTickWidth,
            axisYTickLength: this.data.axisYTickLength,
            axisYDashedTick: this.data.axisYDashedTick,
            axisYDashedTickLength: this.data.axisYDashedTickLength,
            axisYDashedTickSpacing: this.data.axisYDashedTickSpacing,
            showYAxisTickLabels: this.data.showYAxisTickLabels,
            axisYTickLabelAlignment: this.data.axisYTickLabelAlignment,
            axisYTickLabelFont: this.data.axisYTickLabelFont,
            axisYTickLabelPadding: this.data.axisYTickLabelPadding,
            axisYTickLabelMirror: this.data.axisYTickLabelMirror,
            axisYLabelAutoSkip: this.data.axisYLabelAutoSkip,
            axisYLabelAutoSkipPadding: this.data.axisYLabelAutoSkipPadding,
            axisYLabelMinRotation: this.data.axisYLabelMinRotation,
            axisYLabelMaxRotation: this.data.axisYLabelMaxRotation,

            showY2Axis: this.data.showY2Axis,
            axisY2Color: this.data.axisY2Color,
            axisY2Width: this.data.axisY2Width,
            showY2AxisLabel: this.data.showY2AxisLabel,
            axisY2Label: this.data.axisY2Label,
            axisY2LabelFont: this.data.axisY2LabelFont,
            axisY2LabelAlignment: this.data.axisY2LabelAlignment,
            axisY2LabelPadding: this.data.axisY2LabelPadding,
            showY2AxisTicks: this.data.showY2AxisTicks,
            axisY2TickColor: this.data.axisY2TickColor,
            axisY2TickWidth: this.data.axisY2TickWidth,
            axisY2TickLength: this.data.axisY2TickLength,
            axisY2DashedTick: this.data.axisY2DashedTick,
            axisY2DashedTickLength: this.data.axisY2DashedTickLength,
            axisY2DashedTickSpacing: this.data.axisY2DashedTickSpacing,
            showY2AxisTickLabels: this.data.showY2AxisTickLabels,
            axisY2TickLabelAlignment: this.data.axisY2TickLabelAlignment,
            axisY2TickLabelFont: this.data.axisY2TickLabelFont,
            axisY2TickLabelPadding: this.data.axisY2TickLabelPadding,
            axisY2TickLabelMirror: this.data.axisY2TickLabelMirror,
            axisY2LabelAutoSkip: this.data.axisY2LabelAutoSkip,
            axisY2LabelAutoSkipPadding: this.data.axisY2LabelAutoSkipPadding,
            axisY2LabelMinRotation: this.data.axisY2LabelMinRotation,
            axisY2LabelMaxRotation: this.data.axisY2LabelMaxRotation,

            showXGrid: this.data.showXGrid,
            gridXColor: this.data.gridXColor,
            gridXLineWidth: this.data.gridXLineWidth,
            gridXDashedLine: this.data.gridXDashedLine,
            gridXDashedLineLength: this.data.gridXDashedLineLength,
            gridXDashedLineSpacing: this.data.gridXDashedLineSpacing,

            showYGrid: this.data.showYGrid,
            gridYColor: this.data.gridYColor,
            gridYLineWidth: this.data.gridYLineWidth,
            gridYDashedLine: this.data.gridYDashedLine,
            gridYDashedLineLength: this.data.gridYDashedLineLength,
            gridYDashedLineSpacing: this.data.gridYDashedLineSpacing,

            showTitle: this.data.showTitle,
            titleText: this.data.titleText,
            titleFont: this.data.titleFont,
            titleFullSize: this.data.titleFullSize,
            titlePosition: this.data.titlePosition,
            titleAlignment: this.data.titleAlignment,
            titlePadding: this.data.titlePadding,

            showTooltip: this.data.showTooltip,
            tooltipInteractionMode: this.data.tooltipInteractionMode,
            tooltipInteractionIntersect: this.data.tooltipInteractionIntersect,
            tooltipInteractionAxis: this.data.tooltipInteractionAxis,
            tooltipInteractionIncludeInvisible: this.data.tooltipInteractionIncludeInvisible,
            tooltipPosition: this.data.tooltipPosition,
            tooltipPadding: this.data.tooltipPadding,
            tooltipBoxPadding: this.data.tooltipBoxPadding,
            tooltipCaretPadding: this.data.tooltipCaretPadding,
            tooltipCaretSize: this.data.tooltipCaretSize,
            tooltipBorderWidth: this.data.tooltipBorderWidth,
            tooltipBorderColor: this.data.tooltipBorderColor,
            tooltipRoundedCorners: this.data.tooltipRoundedCorners,
            tooltipBackgroundColor: this.data.tooltipBackgroundColor,
            showTooltipTitle: this.data.showTooltipTitle,
            tooltipTitleFont: this.data.tooltipTitleFont,
            tooltipTitleAlignment: this.data.tooltipTitleAlignment,
            tooltipTitleSpacing: this.data.tooltipTitleSpacing,
            tooltipTitleMarginBottom: this.data.tooltipTitleMarginBottom,
            showTooltipBody: this.data.showTooltipBody,
            tooltipBodyFont: this.data.tooltipBodyFont,
            tooltipBodyLabelType: this.data.tooltipBodyLabelType,
            tooltipBodyAlignment: this.data.tooltipBodyAlignment,
            tooltipBodySpacing: this.data.tooltipBodySpacing,
            tooltipUsePointStyle: this.data.tooltipUsePointStyle,
            tooltipShowColorBoxes: this.data.tooltipShowColorBoxes,

            showLegend: this.data.showLegend,
            legendPosition: this.data.legendPosition,
            legendAlignment: this.data.legendAlignment,
            legendMaxWidth: this.data.legendMaxWidth,
            legendMaxHeight: this.data.legendMaxHeight,
            legendDisableClick: this.data.legendDisableClick,
            legendLabelFont: this.data.legendLabelFont,
            legendItemShowBorder: this.data.legendItemShowBorder,
            legendItemBorderColor: this.data.legendItemBorderColor,
            legendItemBorderWidth: this.data.legendItemBorderWidth,
            legendItemBorderRadius: this.data.legendItemBorderRadius,
            legendItemBorderPadding: this.data.legendItemBorderPadding,
            legendLabelBoxWitdh: this.data.legendLabelBoxWitdh,
            legendLabelBoxHeight: this.data.legendLabelBoxHeight,
            legendLabelAlignment: this.data.legendLabelAlignment,
            legendLabelPadding: this.data.legendLabelPadding,
            legendLabelUsePointStyle: this.data.legendLabelUsePointStyle,
            legendLabelBoxRoundedCorners: this.data.legendLabelBoxRoundedCorners,
            showLegendTitle: this.data.showLegendTitle,
            legendTitleText: this.data.legendTitleText,
            legendTitleFont: this.data.legendTitleFont,
            legendTitlePadding: this.data.legendTitlePadding,
            legendHideNullSeries: this.data.legendHideNullSeries,

            enableZoom: this.data.enableZoom,
            enableZoomWheel: this.data.enableZoomWheel,
            zoomWheelSpeed: this.data.zoomWheelSpeed,
            zoomWheelModifierKey: this.data.zoomWheelModifierKey,
            enableZoomDrag: this.data.enableZoomDrag,
            showScrollbar: this.data.showScrollbar,
            scrollbarColor: this.data.scrollbarColor,
            scrollbarHeight: this.data.scrollbarHeight,
            scrollbarRoundedCorners: this.data.scrollbarRoundedCorners,
            zoomDragBacgroundColor: this.data.zoomDragBacgroundColor,
            enableZoomPinch: this.data.enableZoomPinch,
            zoomMode: this.data.zoomMode,
            zoomScaleMode: this.data.zoomScaleMode,

            enablePanning: this.data.enablePanning,
            panningMode: this.data.panningMode,
            panningModifierKey: this.data.panningModifierKey,

            showDatalabels: this.data.showDatalabels,
            datalabelFont: this.data.datalabelFont,
            datalabelHideZero: this.data.datalabelHideZero,
            datalabelMinPercentageThreshold: this.data.datalabelMinPercentageThreshold,
            datalabelAnchor: this.data.datalabelAnchor,
            datalabelAlignment: this.data.datalabelAlignment,
            datalabelOffset: this.data.datalabelOffset,
            datalabelClamp: this.data.datalabelClamp,

            emptyText: this.data.emptyText,

            clickedEvent: this.isEventEnabled('clicked') ? this.triggerEventIfEnabled.bind(this) : undefined
        }

        this.ChartComponent.default(dataSourceResult, this.data.series, config, this.$element.get(0));
    };

    Chart.prototype.afterShown = function () {
        this.$element.css('display', 'inherit');
    };

    Chart.prototype.afterHidden = function () {
        this.$element.css('display', 'none');
    };

    return Chart;
});

